var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Timestamp, File } from '@1amageek/ballcap';
import { Base } from '.';
export class JobReward extends Base {
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('jobRewards');
    }
}
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "clinicId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "clinicName", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "jobOfferId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "jobTitle", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobReward.prototype, "jobOfferThumbnails", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobReward.prototype, "occupations", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobReward.prototype, "medicalDepartments", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "jobDescription", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobReward.prototype, "rewardTypeId", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobReward.prototype, "rewardAmount", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobReward.prototype, "paidRewardAmount", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobReward.prototype, "payments", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobReward.prototype, "employmentId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "workerId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "workerFirstName", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobReward.prototype, "workerLastName", void 0);
__decorate([
    Field,
    __metadata("design:type", File)
], JobReward.prototype, "workerImage", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp)
], JobReward.prototype, "startWorkingTimePerDay", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp)
], JobReward.prototype, "endWorkingTimePerDay", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], JobReward.prototype, "isPayed", void 0);
__decorate([
    Field,
    __metadata("design:type", Object)
], JobReward.prototype, "paymentResult", void 0);
